import { useI18n } from 'vue-i18n'

import { useNovelPageText } from '../novel-page-text.js'

const NS = 'visualGameAdmin.novelPacks.release'
// 本端仓储错误记进记录时，原因短语后面接着 details 的 JSON；取第一段认原因码。
const REASON_HEAD = /^[a-z][a-z0-9_]*$/

/**
 * 发布区的取词：失败原因与连接错误按原因码翻译（发布区专有含义的码优先，其余走 apiError），原文只进 title（R-6）；
 * 发布日志按日志码与参数翻译，此前写入的中文原句原样显示。
 */
export function useReleaseText() {
  const { t, te } = useI18n()
  const { apiError, apiErrorLine, dateTime } = useNovelPageText()
  const tr = (key, params) => t(`${NS}.${key}`, params ?? {})

  /** @param {{ code: string, message: string }} reason */
  function reasonText(reason) {
    const title = [reason.code, reason.message].filter(Boolean).join(' · ')
    if (te(`${NS}.reasonCodes.${reason.code}`)) return { text: tr(`reasonCodes.${reason.code}`), title }
    const head = reason.message.split(/\s/, 1)[0]
    return { text: apiError({ code: reason.code, message: REASON_HEAD.test(head) ? head : reason.message }).text, title }
  }

  /** @param {{ code: string|null, params: Record<string, string|number>, message: string|null }} log */
  function logText(log) {
    if (log.code === null) return { text: log.message, title: '' }
    if (log.code === 'failed') {
      const reason = reasonText({ code: String(log.params.code), message: String(log.params.message) })
      return { text: tr('logs.failed', { reason: reason.text }), title: reason.title }
    }
    return { text: tr(`logs.${log.code}`, log.params), title: '' }
  }

  return { t, tr, apiError, apiErrorLine, dateTime, reasonText, logText }
}

export function recordVariant(status) {
  switch (status) {
    case 'prepared': return 'neutral'
    case 'transferring':
    case 'applying': return 'warning'
    case 'succeeded': return 'success'
    case 'failed': return 'danger'
    default: throw new Error(`Unhandled release status: ${status}`)
  }
}

export function formatBytes(value) {
  if (value < 1024) return `${value} B`
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`
  return `${(value / 1024 / 1024).toFixed(1)} MB`
}
